import React, { useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import * as classRoomSelectors from '@core/selectors/classroom';
import { useSelector } from 'react-redux';
import { useTheme, Alert, Icons } from '@ublend-npm/aulaui-core';
import { createStyles } from './StaffOnlyAlert.styled';

const LIGHT_INFO_OUTLINED_COLOR = '#0088D1';
const DARK_INFO_OUTLINED_COLOR = '#2BB6F6';

const StaffOnlyAlert = () => {
  const [showAlert, setShowAlert] = useState(true);
  const theme = useTheme();
  const styles = createStyles(theme);
  const infoOutlinedColor =
    theme.palette.mode === 'dark'
      ? DARK_INFO_OUTLINED_COLOR
      : LIGHT_INFO_OUTLINED_COLOR;
  // Check if the current user is accessing the space as staff
  const accessingAsStaff = useSelector(
    classRoomSelectors.accessingCurrentSpaceAsStaff
  );
  // Fetch the flag for to determine whether we need to show alert or not
  const { webAppFtSpaceArea202504 } = useFlags();

  // Show alert only if this `webAppFtSpaceArea202504` is true
  const shouldShowAlert =
    accessingAsStaff && showAlert && webAppFtSpaceArea202504;

  if (!shouldShowAlert) return null;

  return (
    <Alert
      severity="info"
      showCloseIcon
      icon={
        <Icons.InfoOutlined
          fontSize="small"
          sx={{ color: infoOutlinedColor }}
        />
      }
      onClose={() => setShowAlert(false)}
      sx={styles.alert}
      tabIndex={0}
    >
      Some actions are not available because you are viewing this space via
      staff access.
    </Alert>
  );
};

export default StaffOnlyAlert;
